export const scalePoint = (point: number[], offSet: { x: number, y: number }, scale: number): number[] => {
    const [x, y] = point;
    return [(x - offSet.x) * scale, (y - offSet.y) * scale]
}

export const invertScalePoint = (point: number[], offSet: { x: number, y: number }, scale: number, scaledMoveOffset: { x: number, y: number } = { x: 0, y: 0 }): number[] => {
    const [x, y] = point;
    const scaledOffset = [offSet.x * scale, offSet.y * scale]
    return [
      (x + scaledOffset[0] + scaledMoveOffset.x)/scale, 
      (y + scaledOffset[1] + scaledMoveOffset.y)/scale
    ]
}

